import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UpcomingShifts = ({ shifts, onShiftClick }) => {
  const upcomingShifts = shifts?.filter(shift => new Date(shift.startTime) > new Date())?.sort((a, b) => new Date(a.startTime) - new Date(b.startTime))?.slice(0, 5);

  const getStatusColor = (status) => {
    const colors = {
      assigned: 'text-blue-700 bg-blue-50',
      requested: 'text-yellow-700 bg-yellow-50',
      available: 'text-green-700 bg-green-50'
    };
    return colors?.[status] || 'text-gray-700 bg-gray-50';
  };

  const getStatusIcon = (status) => {
    const icons = {
      assigned: 'CheckCircle',
      requested: 'Clock',
      available: 'Plus'
    };
    return icons?.[status] || 'Circle';
  };

  const formatShiftTime = (startTime, endTime) => {
    const start = new Date(startTime)?.toLocaleTimeString('de-DE', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
    const end = new Date(endTime)?.toLocaleTimeString('de-DE', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
    return `${start} - ${end}`;
  };

  const formatShiftDate = (date) => {
    return new Date(date)?.toLocaleDateString('de-DE', {
      weekday: 'short',
      day: '2-digit',
      month: '2-digit'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-foreground">Kommende Schichten</h3>
        <Button
          variant="ghost"
          size="sm"
          iconName="ExternalLink"
          iconSize={14}
          onClick={() => window.location.href = '/my-assigned-shifts'}
        >
          Alle anzeigen
        </Button>
      </div>
      {upcomingShifts?.length > 0 ? (
        <div className="space-y-3">
          {upcomingShifts?.map((shift) => (
            <div
              key={shift?.id}
              className="p-3 border border-border rounded-lg hover:bg-muted transition-colors cursor-pointer"
              onClick={() => onShiftClick(shift)}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center space-x-2 mb-1">
                    <Icon 
                      name={getStatusIcon(shift?.status)} 
                      size={14} 
                      className="text-muted-foreground" 
                    />
                    <span className="text-sm font-medium text-foreground">
                      {shift?.department}
                    </span>
                  </div>
                  <p className="text-xs text-muted-foreground mb-2">
                    {formatShiftDate(shift?.startTime)} • {formatShiftTime(shift?.startTime, shift?.endTime)}
                  </p>
                  <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(shift?.status)}`}>
                    {shift?.status === 'assigned' ? 'Zugewiesen' : 
                     shift?.status === 'requested' ? 'Angefragt' : 'Verfügbar'}
                  </div>
                </div>
                <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-6">
          <Icon name="Calendar" size={32} className="text-muted-foreground mx-auto mb-2" />
          <p className="text-sm text-muted-foreground">
            Keine kommenden Schichten
          </p>
        </div>
      )}
    </div>
  );
};

export default UpcomingShifts;